/**
 * authFetch — drop-in replacement for the native fetch() API that
 * automatically attaches the in-memory Bearer token from tokenStore.
 *
 * Usage: identical to fetch(url, options) — returns a native Response.
 */
import { getToken } from './tokenStore.js';

const authFetch = (url, options = {}) => {
  const token = getToken();
  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
};

export default authFetch;
